import { createContext } from "react";

export type ValidationControl = {
  enabled: boolean;
};

export const ValidationControlContext = createContext<ValidationControl | null>(
  null,
);
